import { FEATURED_EDUCATOR_PRINTABLE } from "@/lib/constants/educator-printables";

const downloadButtonClassName =
  "inline-flex w-full max-w-[520px] items-center justify-center rounded-full border-4 border-black bg-black px-8 py-5 charlie-kingdom-font text-xl text-white shadow-[inset_0_-6px_0_rgb(var(--ink-700))] hover:bg-black/90 motion-reduce:transition-none focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-black/30 md:text-2xl lg:w-auto transition-colors";

function DownloadPdfLink() {
  return (
    <a
      href={FEATURED_EDUCATOR_PRINTABLE.pdfUrl}
      target="_blank"
      rel="noreferrer"
      className={downloadButtonClassName}
    >
      <span className="relative -top-1">Download PDF</span>
    </a>
  );
}

export function EducatorPdfSection() {
  const printable = FEATURED_EDUCATOR_PRINTABLE;

  return (
    <section
      aria-labelledby="educator-pdf-heading"
      className="relative overflow-visible bg-[linear-gradient(to_bottom,rgb(var(--cta-yellow-bright)),rgb(var(--cta-orange)))]"
    >
      <div className="container mx-auto px-4 max-w-6xl pt-16 pb-12 lg:py-16">
        <div className="grid grid-cols-1 lg:min-h-[22rem] lg:grid-cols-5 lg:items-stretch lg:gap-12">
          <div className="relative z-10 flex flex-col justify-center gap-5 text-center lg:col-span-2 lg:col-start-1 lg:text-left">
            <h2
              id="educator-pdf-heading"
              className="charlie-kingdom-font text-3xl text-balance md:text-4xl leading-tight"
            >
              {printable.heading}
            </h2>

            <p className="mx-auto max-w-sm text-balance font-semibold text-base leading-relaxed text-black/85 md:text-lg lg:mx-0 lg:max-w-md">
              {printable.body}
            </p>

            <div className="hidden justify-start lg:flex">
              <DownloadPdfLink />
            </div>
          </div>

          <div className="relative z-0 mt-8 lg:col-span-3 lg:col-start-3 lg:row-start-1 lg:mt-0 lg:min-h-[22rem] lg:self-stretch">
            <div className="relative mx-auto w-full max-w-[260px] overflow-hidden max-lg:aspect-[1546/900] sm:max-w-[300px] md:max-w-[340px] lg:absolute lg:inset-x-0 lg:mx-0 lg:max-w-none lg:aspect-auto lg:-top-[calc(4rem+2.5rem)] lg:-bottom-16">
              <img
                src={printable.previewSrc}
                alt={printable.previewAlt}
                width={1546}
                height={1224}
                className="pointer-events-none h-auto w-full select-none"
              />
            </div>
          </div>

          <div className="relative z-10 -mt-10 flex justify-center lg:hidden">
            <DownloadPdfLink />
          </div>
        </div>
      </div>
    </section>
  );
}
